import { createSlice } from "@reduxjs/toolkit";
import { ExcelData, model_type } from "@/types/models";

export type ExcelState = {
  created_at: Date | null;
  doc_count: number;
  doc_link: string;
  mapper: Record<string, string>;
  model_type: model_type | "";
  name: string;
  _id: string;
  excelData: ExcelData | null;
  docs_edit:number[]
};

const initialState: ExcelState = {
  created_at: null,
  doc_count: 0,
  doc_link: "",
  mapper: {},
  model_type: "",
  name: "",
  _id: "",
  excelData: null,
  docs_edit:[]
};

export const excelSlice = createSlice({
  name: "excel",
  initialState,
  reducers: {
    setExcelData: (state, action) => {
      return { ...state, ...action.payload };
    },
    setNewExcelData: (state, action) => {
      state.excelData = null;
      return action.payload;
    },
  },
});

export const { setExcelData, setNewExcelData } = excelSlice.actions;
export const excelReducer = excelSlice.reducer;
